module.exports = __webpack_public_path__ + "LatoLatin-Semibold.008763cc6182e2b7ea62.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.woff2
// module chunks = styles